import { ICopyable } from '../core/copyable.interface';

export class ListLayout implements ICopyable<ListLayout> {
    public id: number = null;
    public organizationId: string = null;
    public name: string = null;
    isLayoutMustFitScreenSize: boolean;
    workflowStepColumnWidth: number = null;
    recordsPerPage: number = null;
    sortAttributeId: number = null;
    sortDirection: string = null;

    public createCopy(): ListLayout {
        const instance = new ListLayout();
        instance.id = this.id;
        instance.name = this.name;
        instance.organizationId = this.organizationId;
        instance.isLayoutMustFitScreenSize = this.isLayoutMustFitScreenSize;
        instance.workflowStepColumnWidth = this.workflowStepColumnWidth;
        instance.recordsPerPage = this.recordsPerPage;
        instance.sortAttributeId = this.sortAttributeId;
        instance.sortDirection = this.sortDirection;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.organizationId = other.organizationId;
        this.isLayoutMustFitScreenSize = other.isLayoutMustFitScreenSize;
        this.workflowStepColumnWidth = other.workflowStepColumnWidth;
        this.recordsPerPage = other.recordsPerPage;
        this.sortAttributeId = other.sortAttributeId;
        this.sortDirection = other.sortDirection;
    }
}
